import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const TasksPage = () => {
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchTasks = async (projectId = "") => {
    try {
      setLoading(true);
      const token = localStorage.getItem("auth_token");
      const user = JSON.parse(localStorage.getItem("user")); // ✅ Parse full user object
      const userId = user?.id;

      let url = `https://loopsneller.com/api/tasks?user_id=${userId}`;
      if (projectId) url += `&project_id=${projectId}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch tasks");

      const data = await response.json();
      setTasks(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchProjects = async () => {
    const token = localStorage.getItem("auth_token");
    const response = await fetch("https://loopsneller.com/api/projects", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    const data = await response.json();
    setProjects(data);
  };

  useEffect(() => {
    fetchTasks();
    fetchProjects();
  }, []);

  const handleFilterChange = (e) => {
    setSelectedProject(e.target.value);
    fetchTasks(e.target.value);
  };

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Your Tasks</h2>
        <select
          className="form-select w-auto"
          value={selectedProject}
          onChange={handleFilterChange}
        >
          <option value="">All Projects</option>
          {projects.map((project) => (
            <option key={project.id} value={project.id}>
              {project.name}
            </option>
          ))}
        </select>
      </div>

      {loading ? (
        <p>Loading tasks...</p>
      ) : tasks.length === 0 ? (
        <p>No tasks found.</p>
      ) : (
        <ul className="list-group">
          {tasks.map((task) => (
            <li
              key={task.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              <div>
                <strong>{task.title}</strong> <br />
                <small className="text-muted">
                  Project: {task.project?.name || "N/A"}
                </small>
              </div>
              <Link to={`/tasks/${task.id}`} className="btn btn-sm btn-primary">
                View More
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TasksPage;
